import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import Bricks from 'bricks.js';

import { DOM_UPDATED, GRID_UPDATED } from '../lib/events';

export default (el, props) => {
    const $el = $(el);

    let $items = $el.find('[data-item]');
    let bricks = null;

    const { layout } = props;

    const layoutSettings = {
        '1-2-3': [
            { columns: 1, gutter: 0 },
            { mq: '750px', columns: 2, gutter: 0 },
            { mq: '1200px', columns: 3, gutter: 0 },
        ],
        '1-2': [
            { columns: 1, gutter: 0 },
            { mq: '750px', columns: 2, gutter: 0 },
        ],
    };

    const reset = () => {
        $el.css({ position: '', width: '', height: '' });
        $items.css({ position: '', top: '', left: '' });
    };
    
    const onArticleListUpdated = () => {
        reset();
        $items = $el.find('[data-item]');
        bricks.pack();
        Dispatch.emit(DOM_UPDATED);
    };
    
    const onResize = () => {
        reset();
        bricks.pack();
        Dispatch.emit(DOM_UPDATED);
    };

    const init = () => {
        bricks = Bricks({
            container: el,
            packed: 'data-packed',
            sizes: layoutSettings[layout]
        });

        bricks.pack();
        Dispatch.emit(DOM_UPDATED);
        
        Dispatch.on(GRID_UPDATED, onArticleListUpdated);
        Viewport.on('resize', onResize);
    };

    const destroy = () => {
        reset();
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};
